import React, { useState } from 'react';
import { isFunction } from 'lodash';
import PropTypes from 'prop-types';
import { SettingsOutlinedIcon } from 'tuui';
import { HeadlessDropdown, pxToRem } from 'taboola-ultimate-ui';
import { useDropdownOptions } from 'hooks';
import { useAvailableLocales, useIntl, useLocale } from 'modules/taboola-common-frontend-modules/i18n';
import LocalesList from './LocalesList';
import OptionWrapper from './OptionWrapper';
import styles from './adminDropdown.module.scss';

const menuStyles = {
    right: 0,
    marginTop: pxToRem(styles['dropdown-marginTop']),
    color: styles['dropdown-color'],
    boxShadow: styles['dropdown-box-shadow'],
};

const routesTransformer = (routes, dependencies) => {
    return routes
        .filter(route => route.hideNavItem && !route.hidden)
        .map(({ permissions, id, basePath = '', href = `${basePath}/${id}`, legacy }) => ({
            permissions,
            href: isFunction(href) ? href(dependencies) : href,
            value: id,
            label: id,
            newTab: legacy,
        }));
};

export const AdminDropdownHeadless = ({
    availableRoutes,
    children,
    open: openProp,
    menuStyles: menuStylesProps = {},
}) => {
    const [open, setOpen] = useState(false);
    const handleToggleDropdown = () => setOpen(!open);
    const [locale, setLocale] = useLocale();
    const itemsAdditionalData = { locale };

    const options = useDropdownOptions(availableRoutes, 'navigation.caption', routesTransformer, itemsAdditionalData);
    const availableLocales = useAvailableLocales();

    return (
        <HeadlessDropdown
            width={styles['dropdown-width']}
            menuStyles={{ ...menuStyles, ...menuStylesProps }}
            className={styles['dropdown']}
            options={options}
            onChange={() => {}}
            optionWrapper={OptionWrapper}
            value={{}}
            open={openProp ?? open}
            onToggleDropdown={handleToggleDropdown}
            menuListRenderer={params => (
                <LocalesList locale={locale} setLocale={setLocale} availableLocales={availableLocales} {...params} />
            )}
        >
            {children}
        </HeadlessDropdown>
    );
};

export const AdminDropdown = props => {
    const { formatMessage } = useIntl();
    const sectionLabel = formatMessage({
        id: 'navigation.caption.label',
        defaultMessage: 'Navigation Menu',
    });

    return (
        <div className={styles['container']} aria-label={sectionLabel}>
            <AdminDropdownHeadless {...props}>
                <div className={styles['icon-container']}>
                    <SettingsOutlinedIcon aria-label="admin-menu-icon" />
                </div>
            </AdminDropdownHeadless>
        </div>
    );
};

AdminDropdown.propTypes = { availableRoutes: PropTypes.array };

AdminDropdown.defaultProps = { availableRoutes: [] };

export default AdminDropdown;
